import React from 'react';

import { ModalContext } from './modal.context';

export const useModal = () => React.useContext(ModalContext);
